export default __webpack_public_path__ + "resources/icons/d311-5797.png";